import React from "react";

const Spinners = () => {
  // document.title = "Загрузка | EyeTech";

  return (
    <div className="dna-loader-container">
      <img
        className="loading-logo"
        src="../../assets/images/logo-dark.png"
        alt="Logo"
      />

      <div className="dna-spinner">
        {Array.from({ length: 15 }, (_, i) => (
          <div className="strand" key={i}>
            <div className="top" style={{ animationDelay: `${i * -0.2}s` }}></div>
            <div className="bottom" style={{ animationDelay: `${-1.5 - i * 0.2}s` }}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Spinners;